var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { SessionProvider } from '../session/session';
const env = process.env.IONIC_ENV;
console.log('ENVIRONMENT', env);
export var ServerEnvironment;
(function (ServerEnvironment) {
    ServerEnvironment["Beta"] = "beta";
    ServerEnvironment["Staging"] = "staging";
    ServerEnvironment["Prod"] = "prod";
})(ServerEnvironment || (ServerEnvironment = {}));
let EnvironmentProvider = EnvironmentProvider_1 = class EnvironmentProvider {
    constructor(session, events) {
        this.session = session;
        this.events = events;
        this.serverEnvironment$ = new BehaviorSubject(this.defaultServerEnvironment());
        this.retrieveStoredServerEnvironment();
        // Reset the server environment after login events since local storage may have been cleared
        this.events.subscribe('userDidLogout', () => {
            this.session.set(EnvironmentProvider_1.SERVER_ENVIRONMENT_KEY, this.serverEnvironment$.value);
        });
        this.events.subscribe('userDidLogin', () => {
            this.session.set(EnvironmentProvider_1.SERVER_ENVIRONMENT_KEY, this.serverEnvironment$.value);
        });
    }
    // Environment Management
    isServerBeta() {
        return this.serverEnvironment$.value === ServerEnvironment.Beta;
    }
    isServerStaging() {
        return this.serverEnvironment$.value === ServerEnvironment.Staging;
    }
    isServerProd() {
        return this.serverEnvironment$.value === ServerEnvironment.Prod;
    }
    serverVars() {
        if (this.isServerBeta()) {
            return betaServer;
        }
        else if (this.isServerStaging()) {
            return stagingServer;
        }
        else {
            return prodServer;
        }
    }
    switchServer(env) {
        return this.session
            .set(EnvironmentProvider_1.SERVER_ENVIRONMENT_KEY, env)
            .then(() => {
            this.serverEnvironment$.next(env);
        });
    }
    defaultServerEnvironment() {
        return env === 'prod' ? ServerEnvironment.Prod : ServerEnvironment.Beta;
    }
    retrieveStoredServerEnvironment() {
        return this.session
            .get(EnvironmentProvider_1.SERVER_ENVIRONMENT_KEY)
            .then((value) => {
            this.serverEnvironment$.next(value || this.defaultServerEnvironment());
        });
    }
};
EnvironmentProvider.SERVER_ENVIRONMENT_KEY = 'SERVER_ENVIRONMENT';
EnvironmentProvider = EnvironmentProvider_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SessionProvider, Events])
], EnvironmentProvider);
export { EnvironmentProvider };
export const betaServer = {
    apiEndpoint: 'https://api.beta.startyoshi.com/v0',
    opsEndpoint: 'https://ops.beta.startyoshi.com/v0',
    shareUrl: 'http://api.beta.startyoshi.com/users/',
    environmentName: 'Beta',
    gaId: 'UA-62595537-5',
    stripePublishableKey: 'pk_test_HcrdetnFsWge0pK6z1g78ls2',
    fbAppId: 942555735798943,
};
export const stagingServer = {
    apiEndpoint: 'https://api.staging.startyoshi.com/v0',
    opsEndpoint: 'https://ops.staging.startyoshi.com/v0',
    shareUrl: 'http://www.staging.startyoshi.com/users/',
    environmentName: 'Staging',
    gaId: 'UA-62595537-5',
    stripePublishableKey: 'pk_test_HcrdetnFsWge0pK6z1g78ls2',
    fbAppId: 942555735798943,
};
export const prodServer = {
    apiEndpoint: 'https://api.startyoshi.com/v0',
    opsEndpoint: 'https://ops.startyoshi.com/v0',
    environmentName: 'Production',
    shareUrl: 'http://www.startyoshi.com/users/',
    gaId: 'UA-62595537-5',
    stripePublishableKey: 'pk_live_TsPI4HEiJ0TNO2Zbhw6iSS12',
    fbAppId: 942555735798943,
};
var EnvironmentProvider_1;
//# sourceMappingURL=environment.js.map


// WEBPACK FOOTER //
// ./src/providers/environment/environment.ts.pre-build-optimizer.js